import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-browser-note",
  templateUrl: "./browser-note.component.html",
  styleUrls: ["./browser-note.component.scss"],
})
export class BrowserNoteComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
